import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabase"; // Import your Supabase client
import { useAuth } from "../context/AuthContext"; // Assuming you have AuthContext to manage user roles
import { toast } from "react-hot-toast"; // For notifications

export default function UserList() {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const { role } = useAuth(); // Get the user role from the context

	// Fetch users from Supabase
	useEffect(() => {
		async function fetchUsers() {
			if (role !== "admin") {
				// If the user is not an admin, redirect or show an error
				toast.error("You do not have permission to view this page.");
				return;
			}

			const { data, error } = await supabase
				.from("profiles") // Query the 'profiles' table to get all users
				.select("id, email, role") // Select the relevant columns (adjust according to your schema)
				.order("email"); // Optionally order by email or another column

			if (error) {
				toast.error("Error fetching users: " + error.message);
				console.error(error);
			} else {
				setUsers(data);
			}
			setLoading(false);
		}

		fetchUsers();
	}, [role]); // Re-run when role changes

	if (loading) {
		return (
			<div className="loading">
				<div>
					<i className="pi pi-spin pi-spinner"></i>
				</div>
			</div>
		);
	}

	return (
		<div className="main">
			<div className="user-list__wrapper">
				<div className="user-list__lead">
					<h1>Users</h1>
					<Link to="/add-user" className="button green">
						<i className="pi pi-plus"></i>
						Add User
					</Link>
				</div>

				<div className="user-list__row header">
					<div className="user">Email</div>
					<div className="role">Role</div>
				</div>

				{users.map((user) => (
					<div className="user-list__row" key={user.id}>
						<div className="user">{user.email}</div>
						<div className="role">{user.role}</div>
					</div>
				))}
			</div>
		</div>
	);
}
